import apiClient from '@/shared/services/api/apiClient';

export const getAdminDashboard = async () => {
  const response = await apiClient.get(
    '/admin/dashboard',
    { showLoader: true } as any
  );

  return response.data.data;
};